define(['underscore', 'bootstrap/tooltip'], function (_, Tooltip) {
    'use strict';
    /*
     * @doc - Initialize on a container element where children have appropriate markup
     * see - https://getbootstrap.com/docs/5.2/components/tooltips/#tooltips-on-links
     * ex - <span data-bs-toggle="tooltip" ... >
     */
    return (config, target) => {
        [...target.querySelectorAll('[data-bs-toggle="tooltip"]')].map(element => new Tooltip(element, config));
    };
});

